module.exports = __webpack_public_path__ + "img/27600.a2900b9c.jpg";